const NovaExpanedLogo = (props: any) => {
  return (
    <svg
      width="129"
      height="29"
      viewBox="0 0 129 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_2)">
        <path
          d="M22.8 18.5L9 0.4H0V27.9H7.3V9.3L21.5 27.9H30V0.4H22.7V18.5H22.8Z"
          fill="url(#paint0_linear_1_2)"
        />
        <path
          d="M50.8 0C41.1 0 34.9 5.9 34.9 14.3C34.9 22.7 41.1 28.5 50.8 28.5C60.5 28.5 66.7 22.7 66.7 14.3C66.7 5.9 60.6 0 50.8 0ZM50.8 22.2C45.5 22.2 42.4 18.9 42.4 14.3C42.4 9.7 45.6 6.3 50.8 6.3C56 6.3 59.3 9.8 59.3 14.3C59.3 18.8 56.2 22.2 50.8 22.2Z"
          fill="url(#paint1_linear_1_2)"
        />
        <path
          d="M84.2 20.4L75 0.4H67.3L80.2 27.9H88.1L101.1 0.4H93.4L84.2 20.3V20.4Z"
          fill="url(#paint2_linear_1_2)"
        />
        <path
          d="M129 28H121.3L118.9 22.8L116.2 16.9L111.9 8L107.6 16.9H107.7L104.9 22.8L102.4 28H94.8L107.9 0.4H115.9L129 28Z"
          fill="url(#paint3_linear_1_2)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1_2"
          x1="-1.59"
          y1="-3.09"
          x2="23.41"
          y2="22.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E2303C" />
          <stop offset="1" stop-color="#F0756B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_2"
          x1="49.56"
          y1="-0.59"
          x2="51.56"
          y2="23.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.2" stop-color="#F05967" />
          <stop offset="0.7" stop-color="#E87B61" />
          <stop offset="1" stop-color="#ED895C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1_2"
          x1="82.46"
          y1="-6.18"
          x2="91.46"
          y2="27.82"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F26865" />
          <stop offset="0.6" stop-color="#F68F65" />
          <stop offset="0.8" stop-color="#F79656" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1_2"
          x1="120.36"
          y1="2.62"
          x2="112.16"
          y2="27.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F16260" />
          <stop offset="0.6" stop-color="#F68D60" />
          <stop offset="0.8" stop-color="#F89F5F" />
        </linearGradient>
        <clipPath id="clip0_1_2">
          <rect width="129" height="28.5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NovaExpanedLogo;
